import { render, staticRenderFns } from "./TgHomeRecommend.vue?vue&type=template&id=25b049c8&"
import script from "./TgHomeRecommend.vue?vue&type=script&lang=js&"
export * from "./TgHomeRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports